module.exports = __webpack_public_path__ + "img/3.43e2edd2.png";